<template>
    <v-carousel
    hide-delimiters 
    height="500" 
    v-bind:class="{ [`elevation-${selected}`]: true }">
            <v-carousel-item
                v-for="(item,i) in items"
                :key="i"
                :src="item.src"
            ></v-carousel-item>
    </v-carousel>
</template>

<script>
export default {
     data: () => ({
      
            items: [
        {
          src: require('../assets/qudi/qudi (1).jpg')
        },
        {
          src: require('../assets/qudi/qudi (2).jpg')
        },
        {
          src: require('../assets/qudi/qudi (3).jpg')       
        },
        {
          src: require('../assets/qudi/qudi (4).jpg')
        },
        {
          src: require('../assets/qudi/qudi (5).jpg')       
        },
        {
          src: require('../assets/qudi/qudi (6).jpg')       
        },
        {
          src: require('../assets/qudi/qudi (7).jpg')       
        },
        {
          src: require('../assets/qudi/qudi (8).jpg')       
        },
        {
          src: require('../assets/qudi/qudi (9).jpg')       
        },
        {
          src: require('../assets/qudi/qudi (10).jpg')       
        },
        {
          src: require('../assets/qudi/qudi (11).jpg')       
        },
        {
          src: require('../assets/qudi/qudi (12).jpg')       
        },

      ],
      selected: 24
     })
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/qudi.vue